import { memo, useCallback } from 'react';
import { Icon } from '@amzn/awsui-components-core';
import { PopoverDialog } from './PopoverDialog';
import { useSuggestionNavigationService } from '../../contexts/SuggestionNavigationServiceContext';

interface PatternSuggestionPopoverProps {
  readonly target: DOMRect;
  readonly onClose: () => void;
  readonly onEdit: () => void;
}

/** Popover shown when navigation lands on a task title/description that has AI suggestions. */
export const PatternSuggestionPopover = memo(function PatternSuggestionPopover({
  target,
  onClose,
  onEdit,
}: PatternSuggestionPopoverProps) {
  const navigationService = useSuggestionNavigationService();

  const handleNavigateLeft = useCallback(() => {
    navigationService.movePrev();
  }, [navigationService]);

  const handleNavigateRight = useCallback(() => {
    navigationService.moveNext();
  }, [navigationService]);

  return (
    <PopoverDialog
      target={target}
      icon={<Icon name="status-info" />}
      title="AI Suggestions Available"
      description="To view and act on suggestions, please click 'Edit' below."
      mode="edit"
      onClose={onClose}
      onEdit={onEdit}
      isNavigateLeftEnabled={navigationService.hasPrev}
      isNavigateRightEnabled={navigationService.hasNext}
      onNavigateLeft={handleNavigateLeft}
      onNavigateRight={handleNavigateRight}
    />
  );
});
